export default __webpack_public_path__ + "static/media/1.5af0313f.jpg";